import { Icons, List, ListItem } from '@healthinal/ui';
import { MenuLink } from '../../../components/MenuLink.tsx';

export function PatientsSideNavigation({ patientId }: { patientId: string }) {
  return (
    <List sx={{ maxWidth: 208, p: 0, '--ListItem-radius': '8px', textDecoration: 'none' }}>
      <ListItem>
        <MenuLink
          icon={<Icons.AccountCircle />}
          to="/patients/$patientId"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId } as const}
          replace
          activeOptions={{ exact: true }}>
          Fallmanagement
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.Analytics />}
          to="/patients/$patientId/anamnesis"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Anamnese
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.AssignmentTurnedIn />}
          to="/patients/$patientId/diagnostics"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Diagnostik
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.MedicationLiquid />}
          to="/patients/$patientId/therapy"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Therapie
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.Hub />}
          to="/patients/$patientId/network"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Netzwerk
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.History />}
          to="/patients/$patientId/history"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Verlauf
        </MenuLink>
      </ListItem>
      <ListItem>
        <MenuLink
          icon={<Icons.Description />}
          to="/patients/$patientId/document"
          // @ts-expect-error to cope with typing challenges
          params={{ patientId }}
          replace>
          Dokumente
        </MenuLink>
      </ListItem>
    </List>
  );
}
